/**
 * Main Module
 * 
 * This is the main entry point for the AS Components library.
 * It re-exports all important functions and types from the exports.ts file.
 * 
 * Users can import directly from this file:
 * import { reactiveStore, AsReactiveComponent } from 'as-components.v0.0.10.m.js';
 */


declare global{
  interface Window{
    verbose:boolean,
    devlogTraces:boolean,
    fakeProduction:boolean
  }
}

// Use a setter to detect when verbose is enabled
let _verbose = false;
Object.defineProperty(window, 'verbose', {
  get: () => _verbose,
  set: (value: boolean) => {
    _verbose = value;
    if (value === true) {
      console.log('%c[AS-COMPONENTS] Verbose ON', 'color: #4CAF50; font-weight: bold;');
    }
  },
  configurable: true
});

window.devlogTraces = false
window.fakeProduction = false

// Import global styles
import './as-components.css';

// Re-export everything from exports.ts
export * from './exports.ts';

// Import components to register them
import './components/enabledComponents.ts';
import { detectDeviceInfo } from './logic/utils.ts';
import './logic/debug.ts';

// Check if we're in development mode (either dev server or development build)
if (import.meta.env.DEV || import.meta.env.BUILD_DEV) {
  console.log('AS Components is running in development mode', import.meta.env);
}
// export type { AsReactiveComponent,SubbedProps,UpdateHandler } from './components/base/as-reactive-component.ts';

